<!-- =========================================================================================
  File Name: Profile.vue
  Description: Profile Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <form>
      <div class="vx-row mb-6">
        <div class="vx-col md:w-1/2 w-full ql-container">
          <h4 class="p-3">Add Changelog</h4>
          <vx-card class="overflow-hidden">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Build number</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="Build number"
                  placeholder="Build number"
                  class="w-full"
                  v-model="taskLocal.build"
                  :color="validateForm ? 'success' : 'danger'"
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>App version</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="App version"
                  placeholder="App version"
                  class="w-full"
                  v-model="taskLocal.version"
                  :color="validateForm ? 'success' : 'danger'"
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Changelog title</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="Changelog Title"
                  placeholder="Changelog Title"
                  class="w-full"
                  v-model="taskLocal.changelog_title"
                  :color="validateForm ? 'success' : 'danger'"
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Changelog date</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="Changelog date"
                  class="w-full"
                  v-model="taskLocal.date"
                  type="date"
                  :color="validateForm ? 'success' : 'danger'"
                />
              </div>
            </div>
            <label>Changelog summary</label>
            <vs-textarea
              v-validate="'required'"
              class="output-view"
              rows="7"
              placeholder="e.g.
              <ul>
                <li>Changelog item 1</li>
                <li>Changelog item 2</li>
                <li>Changelog item 3</li>
              </ul>
              "
              v-model="taskLocal.changelog_summary"
              :color="validateForm ? 'success' : 'danger'"
            />
            <!-- <quill-editor v-model="taskLocal.changelog_summary" :options="editorOption" class="output-view" /> -->
            <!-- <vue-editor v-model="taskLocal.changelog_summary" :editorToolbar="customToolbar"></vue-editor> -->
            <div class="p-4">
              <vs-button @click="submitAboutText" class="w-full">
                {{ edit_id == "" ? "Submit" : "Update" }}
              </vs-button>
              <vs-button
                v-if="edit_id"
                @click="clearFields"
                class="w-full mt-3"
                color="gray"
              >
                Cancel
              </vs-button>
            </div>
          </vx-card>
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <h4 class="p-3">View Changelog</h4>
          <vx-card
            class="overflow-hidden custom-card"
            v-for="changelog in all_changelog"
            :key="changelog.build"
          >
            <div>
              <div class="action-btn">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  class="ml-2"
                  @click.stop="editData(changelog)"
                />
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="deleteItemData(changelog)"
                />
              </div>

              <div class="">
                <h3 class="version">
                  Build
                  {{ changelog.build }}
                  <span
                    class="float-right justify-content-center"
                    style="font-size: 12px"
                    >{{ getDateFormat(changelog.date) }}</span
                  >
                </h3>
                <div class="body">
                  <h6 class="title">{{ changelog.changelog_title }}</h6>
                  <div class="description" v-html="changelog.changelog_summary">
                    <!-- {{ changelog.changelog_summary }} -->
                  </div>
                </div>
              </div>
            </div>
          </vx-card>
          <infinite-loading  :identifier="identifier" @infinite="infiniteHandler"></infinite-loading>

        </div>
      </div>
    </form>
  </div>
</template>

<script>
import DataProvider from "../../../services/data-provider";
// import { quillEditor } from "vue-quill-editor";
// import { VueEditor } from "vue2-editor";
import moment from "moment";
import firebase, { database } from "firebase/app";
import "firebase/firestore";
import Utilities from "../../../services/utilities";
import InfiniteLoading from "vue-infinite-loading";

export default {
  data() {
    return {
      edit_id: "",
      offset_value:0,
      identifier:true,
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
      ],
      editorOption: {
        modules: {
          toolbar: [["bold", "italic", "list", "underline"]],
        },
        theme: "snow", // or 'bubble'
      },
      all_changelog: [],
      taskLocal: {
        build: "",
        version: "",
        changelog_title: "",
        changelog_summary: "",
        date: "",
      },
    };
  },
  methods: {
    getDateFormat(date) {
      return moment(date).format("MMM DD, YYYY");
    },
    clearFields() {
      Object.assign(this.taskLocal, {
        build: "",
        version: "",
        changelog_title: "",
        changelog_summary: "",
        date: "",
      });
      this.edit_id = "";
    },
    submitAboutText() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.edit_id == "") {
            // this.taskLocal.date = new Date(this.taskLocal.date);
            // console.log(new Date(this.taskLocal.date));
            this.$vs.loading();
            DataProvider.postDataToCloud("/admin-changelog", {
              ...this.taskLocal,
              date: this.taskLocal.date,
            }).then(
              (data) => {
                console.log("data", data);
                this.clearFields();
                // this.getData();
                this.all_changelog = [];
                this.identifier = !this.identifier;
                this.$vs.loading.close();
              },
              (err) => {
                this.$vs.loading.close();
                DataProvider.sendSentryErrorLog(err)
                 if (err.message.includes("403")) {
                this.$vs.notify({
                  color: "warning",
                  title: "Access denied!",
                });
              }
              }
            );
          } else {
            this.$vs.loading();
            DataProvider.updateFirestoreCloudData(
              "/admin-changelog/"+this.edit_id,
              this.taskLocal,
            ).then(
              (data) => {
                console.log("success:", data);
                // this.getData();
                this.all_changelog = [];
                this.identifier = !this.identifier;
                this.clearFields();
                this.$vs.loading.close();
              },
              (err) => {
                console.log("error:", err);
                DataProvider.sendSentryErrorLog(err)
                this.$vs.loading.close();
                 if (err.message.includes("403")) {
                this.$vs.notify({
                  color: "warning",
                  title: "Access denied!",
                });
              }
              }
            );
          }
        }
      });
    },
    infiniteHandler($state) {
      this.offset_value = this.all_changelog.length;
      DataProvider.getDataFromCloudWithPagination("/admin-changelog/", this.offset_value).then(
        (data) => {
          console.log("getDataFromCloud in infiniteHandler:", data);
          if (data.data.length!=0) {
            const all_changelog = data.data.sort((a, b) => b.date - a.date);
            const all_concat_changelog = this.all_changelog.concat(
              all_changelog
            );
            this.all_changelog = all_concat_changelog;
            $state.loaded();
          } else {
            $state.complete();
          }
        },
        (err) => {
          DataProvider.sendSentryErrorLog(err)
          console.log("err:", err);
          $state.complete();
        }
      );
    },
    getData() {
      this.$vs.loading();
      this.offset_value =0
      DataProvider.getDataFromCloudWithPagination("/admin-changelog",this.offset_value).then(
        (data) => {
          console.log("getDataFromCloud:", data);
          if (data.data) this.all_changelog = data.data.sort((a, b) => b.date - a.date)
          this.$vs.loading.close();
        },
        (err) => {
          DataProvider.sendSentryErrorLog(err)
          this.$vs.loading.close();
        }
      );
    },

    deleteItemData(data) {
      console.log("delete:", data);
      Utilities.confirmaionDialog(
        "Are you sure you want to delete this item?",
        "You won't be able to revert this!",
        "Yes, delete it!"
      ).then((result) => {
        if (result.value) {
          this.$vs.loading();
          DataProvider.deleteItemCloudFirestore("/admin-changelog/", data.id).then(
            (data) => {
              console.log("deleted:", data);
              this.$vs.loading.close();
              // this.getData();
              this.all_changelog = [];
                this.identifier = !this.identifier;
              Utilities.confirmDialog(
                "Deleted!",
                "Your item has been deleted.",
                "success"
              );
            },
            (err) => {
              console.log("Error in delte:", err);
              this.$vs.loading.close();
              DataProvider.sendSentryErrorLog(err)
              if (err.message.includes("403")) {
                this.$vs.notify({
                  color: "warning",
                  title: "Access denied!",
                });
              }
            }
          );
        }
      });
    },
    editData(data) {
      console.log("edit:", data);
      this.edit_id = data.id;
      this.taskLocal.build = data.build;
      this.taskLocal.version = data.version;
      this.taskLocal.changelog_title = data.changelog_title;
      this.taskLocal.changelog_summary = data.changelog_summary;
      this.taskLocal.date = data.date;
    },
  },
  computed: {
    validateForm() {
      return !this.errors.any();
    },
  },
  components: {
    // quillEditor,
    // VueEditor,
    InfiniteLoading,
  },
  mounted() {
    // this.getData();
  },
  beforeDestroy() {
    if (!this.wasSidebarOpen) this.$store.commit("TOGGLE_REDUCE_BUTTON", false);
  },
};
</script>


<style lang="scss">
// @import "@/assets/scss/vuexy/pages/profile.scss";
.output-view {
  .ql-container {
    //   margin-top: 10px;
    // border: 1px solid #e8e8e8;
    min-height: 200px;
    // padding: 10px;
  }
}
.version {
  padding: 5px;
  background-color: #bfbfbf;
}
.custom-card .vx-card__body {
  padding: 0 !important;
}
.custom-card {
  margin-top: 12px;
}
.body {
  padding: 8px;
}
.description ul {
  list-style-type: disc;
  padding-left: 17px;
}
.action-btn {
  float: right;
  margin: 5px;
  color: #000;
  cursor: pointer;
}
</style>
